import React from 'react';
import { connect } from 'react-redux';
import loading from '../../Assets/images/loading.gif';

const Loading = props => {
  if (!props.loading) {
    return <div />;
  }
  return (
    <div className="loading">
      <img className="loader" src={loading} alt="Loading" />
    </div>
  );
};
const mapStateToProps = state => ({
  loading: state.loading,
});

export default connect(mapStateToProps)(Loading);
